export var ColorHex;
(function (ColorHex) {
    ColorHex["axablue"] = "#00008f";
    ColorHex["axared"] = "#ff1721";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["deepsaphire"] = "#00005b";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["sttropaz"] = "#2425aa";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["azure"] = "#3032c1";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["darkindigo"] = "#3b3fd8";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["indigo"] = "#494df4";
    /** @deprecated use ColorSemanticHex.neutral80 */
    ColorHex["mineshaft"] = "#333";
    /** @deprecated use ColorSemanticHex.neutral70 */
    ColorHex["scorpion"] = "#5f5f5f";
    /** @deprecated use ColorSemanticHex.neutral70 or ColorSemanticHex.neutral60 */
    ColorHex["dimgray"] = "#6f6f6f";
    /** @deprecated use ColorSemanticHex.neutral60 */
    ColorHex["dustygray"] = "#999";
    /** @deprecated use ColorSemanticHex.neutral60 or ColorSemanticHex.neutral50 */
    ColorHex["lightgray"] = "#b3b3b3";
    /** @deprecated use ColorSemanticHex.neutral50 */
    ColorHex["silver"] = "#ccc";
    /** @deprecated use ColorSemanticHex.neutral40 */
    ColorHex["mercury"] = "#e5e5e5";
    /** @deprecated use ColorSemanticHex.neutral40 or ColorSemanticHex.neutral30 */
    ColorHex["whitesmoke"] = "#f1f1f1";
    /** @deprecated use ColorSemanticHex.neutral30 */
    ColorHex["wildsand"] = "#f5f5f5";
    /** @deprecated use ColorSemanticHex.neutral20 */
    ColorHex["alabster"] = "#fafafa";
    /** @deprecated use ColorSemanticHex.neutral20 or ColorSemanticHex.neutral10 */
    ColorHex["ghostwhite"] = "#f8f8ff";
    /** @deprecated use ColorSemanticHex.neutral10 */
    ColorHex["white"] = "#fff";
    ColorHex["transparent"] = "transparent";
    ColorHex["violet"] = "#9064b5";
    ColorHex["orange"] = "#fa5d02";
    ColorHex["fire"] = "#b13601";
    ColorHex["shytomato"] = "#c91432";
    ColorHex["green"] = "#47a80d";
    ColorHex["forest"] = "#2b6e00";
    ColorHex["darkgreen"] = "#1c4701";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["babyblue"] = "#b8d8fd";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["pacific"] = "#00a3ba";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["logan"] = "#9190ac";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["aquagreen"] = "#9fd9b4";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["greyjoy"] = "#9fbeaf";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["cottoncandy"] = "#fad6de";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["azalea"] = "#f1afc6";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["antiquewhite"] = "#fbead8";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["acid"] = "#f0ff93";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["dune"] = "#fcd385";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["oceanblue"] = "#4976ba";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["viridiangreen"] = "#668980";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["teal"] = "#027180";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["burntsienna"] = "#f07662";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["tosca"] = "#914146";
    /** @deprecated Update https://zeroheight.com/0764998e4/p/67128f-couleurs/b/71d439. */
    ColorHex["apache"] = "#ddbe65";
    ColorHex["burntsienna400"] = "#f28878";
    ColorHex["burntsiennaClassic"] = "#ef6b57";
    ColorHex["burntsienna600"] = "#bf5545";
    ColorHex["apache400"] = "#A79666";
    ColorHex["apacheClassic"] = "#8A7333";
    ColorHex["apache600"] = "#6E5C28";
    ColorHex["apache700"] = "#4B3E1B";
    ColorHex["apache800"] = "#241D0C";
    ColorHex["oceanblue400"] = "#7698CB";
    ColorHex["oceanblueClassic"] = "#4976BA";
    ColorHex["oceanblue600"] = "#3A5E94";
    ColorHex["oceanblue700"] = "#274168";
    ColorHex["oceanblue800"] = "#17273E";
    ColorHex["teal400"] = "#41949F";
    ColorHex["tealClassic"] = "#027180";
    ColorHex["teal600"] = "#015A66";
    ColorHex["teal700"] = "#014750";
    ColorHex["teal800"] = "#002126";
    ColorHex["tosca400"] = "#AC7074";
    ColorHex["toscaClassic"] = "#914146";
    ColorHex["tosca600"] = "#743438";
    ColorHex["tosca700"] = "#6A2F33";
    ColorHex["tosca800"] = "#321618";
    ColorHex["viridiangreen400"] = "#738D87";
    ColorHex["viridiangreenClassic"] = "#5B7B73";
    ColorHex["viridiangreen600"] = "#48625C";
    ColorHex["viridiangreen700"] = "#32433F";
    ColorHex["viridiangreen800"] = "#181F1E";
    ColorHex["ghostwhite400"] = "#FAFAFF";
    ColorHex["ghostwhiteClassic"] = "#F8F8FF";
    ColorHex["ghostwhite600"] = "#C6C6CC";
    ColorHex["ghostwhite700"] = "#959599";
    ColorHex["ghostwhite800"] = "#959599";
    ColorHex["acid400"] = "#F3FFA9";
    ColorHex["acidClassic"] = "#F0FF93";
    ColorHex["acid600"] = "#C0CC76";
    ColorHex["acid700"] = "#909958";
    ColorHex["acid800"] = "#60663B";
    ColorHex["aquagreen400"] = "#B7E3C7";
    ColorHex["aquagreenClassic"] = "#9FD9B4";
    ColorHex["aquagreen600"] = "#7FAE90";
    ColorHex["aquagreen700"] = "#668B73";
    ColorHex["aquagreen800"] = "#526F5C";
    ColorHex["azalea400"] = "#E7ABBB";
    ColorHex["azaleaClassic"] = "#E196AA";
    ColorHex["azalea600"] = "#B47888";
    ColorHex["azalea700"] = "#875A66";
    ColorHex["azalea800"] = "#5A3C44";
    ColorHex["cottoncandy400"] = "#FBDEE5";
    ColorHex["cottoncandyClassic"] = "#FAD6DE";
    ColorHex["cottoncandy600"] = "#C8ABB2";
    ColorHex["cottoncandy700"] = "#968085";
    ColorHex["cottoncandy800"] = "#645659";
    ColorHex["dune400"] = "#FDDC9D";
    ColorHex["duneClassic"] = "#FCD385";
    ColorHex["dune600"] = "#CAA96A";
    ColorHex["dune700"] = "#977F50";
    ColorHex["dune800"] = "#655435";
    ColorHex["greyjoy400"] = "#B2CBBF";
    ColorHex["greyjoyClassic"] = "#9FBEAF";
    ColorHex["greyjoy600"] = "#7F988C";
    ColorHex["greyjoy700"] = "#5F7269";
    ColorHex["greyjoy800"] = "#404C46";
    ColorHex["igloo400"] = "#C4D9F1";
    ColorHex["iglooClassic"] = "#B5D0EE";
    ColorHex["igloo600"] = "#91A6BE";
    ColorHex["igloo700"] = "#6D7D8F";
    ColorHex["igloo800"] = "#48535F";
    ColorHex["logan400"] = "#A7A6BD";
    ColorHex["loganClassic"] = "#9190AC";
    ColorHex["logan600"] = "#74738A";
    ColorHex["logan700"] = "#575667";
    ColorHex["logan800"] = "#3A3A45";
    ColorHex["pacific400"] = "#33BDD1";
    ColorHex["pacificClassic"] = "#00ADC6";
    ColorHex["pacific600"] = "#008A9E";
    ColorHex["pacific700"] = "#006877";
    ColorHex["pacific800"] = "#00454F";
})(ColorHex || (ColorHex = {}));
